import serviceTwo from './serviceTwo';
import { UrlBuilder } from './url-builder';

export const getNewUpdateList = async () => {
  const builder = new UrlBuilder(`/updates/get-latest?platform=W`);

  const response = await serviceTwo.getTwo(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};
